import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Toast, Variant } from '@leafygreen-ui/toast';

import { getAppId, getGroupId } from 'baas-ui/app/selectors';
import { SavedTriggerNameContext } from 'baas-ui/events/context/savedTriggerNameContext';
import urls from 'baas-ui/urls';

export const TestSelector = {
  TriggerSavedToast: 'trigger-saved-toast',
};

export const TriggerToast: React.FC = () => {
  const appId = useSelector(getAppId);
  const groupId = useSelector(getGroupId);
  const { savedTriggerName, setSavedTriggerName } = useContext(SavedTriggerNameContext);
  const triggersHomeUrl = urls.groups().group(groupId).apps().app(appId).triggers().list();

  return (
    <Toast
      data-testid={TestSelector.TriggerSavedToast}
      open={!!savedTriggerName}
      onClose={() => setSavedTriggerName('')}
      variant={Variant.Success}
      title="Trigger changes have been saved"
      description={
        <>
          {savedTriggerName} has been successfully saved. <Link to={triggersHomeUrl}>Triggers Home</Link>
        </>
      }
    />
  );
};
